module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-newsletter-signup"
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "name": "u-anim-fade"
    }
  }, [(!_vm.formSuccess && !_vm.loading) ? _c('div', [_c('label', {
    staticClass: "c-newsletter-signup__label"
  }, [_c('h2', {
    staticClass: "c-newsletter-signup__headline"
  }, [_vm._v(_vm._s(_vm.newsletter_signup_label))]), _vm._v(" "), _c('div', {
    staticClass: "c-newsletter-signup__inputcontainer"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.emailString),
      expression: "emailString"
    }],
    class: 'c-newsletter-signup__input' + (_vm.errors.has('E-mail') ? ' c-newsletter-signup__input--error' : ''),
    attrs: {
      "placeholder": "E-Mail",
      "type": "text",
      "name": "E-mail"
    },
    domProps: {
      "value": (_vm.emailString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "name": "u-anim-fade"
    }
  }, [(_vm.errors.has('E-mail')) ? _c('h3', {
    staticClass: "c-newsletter-signup__error"
  }, [_vm._v(_vm._s(_vm.errors.first('E-mail')))]) : _vm._e()])], 1), _vm._v(" "), _c('button', {
    staticClass: "c-newsletter-signup__button",
    attrs: {
      "disabled": _vm.errors.has('E-mail') ||  _vm.emailString.length < 1
    },
    on: {
      "click": function($event) {
        _vm.sendData()
      }
    }
  }, [_vm._v(_vm._s(_vm.newsletter_signup_button_text))])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "name": "u-anim-fade"
    }
  }, [(_vm.loading) ? _c('c-loader', {
    staticClass: "c-newsletter-signup__loader"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.formMessage && !_vm.loading) ? _c('div', {
    class: 'c-newsletter-signup__message-container' + (_vm.formSuccess ? ' c-newsletter-signup__message-container--success' : '') + (!_vm.formSuccess && _vm.formMessage ? ' c-newsletter-signup__message-container--error' : '')
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "name": "u-anim-fade"
    }
  }, [(_vm.formSuccess) ? _c('h3', {
    staticClass: "c-newsletter-signup__message"
  }, [_vm._v(_vm._s(_vm.formMessage))]) : _c('h3', {
    staticClass: "c-newsletter-signup__message c-newsletter-signup__message--error",
    domProps: {
      "innerHTML": _vm._s(_vm.formMessage)
    }
  })])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-290cbc70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsletterSignup.vue
// module id = 257
// module chunks = 0